const bank = process.env.BANK

const componentConfig = {
  callUs: {
    /*
      component: Support.jsx
      route: /support
    */
    viewProps: {
      isVisible: () => {
        const supportedBanks = ['NEXIBUSINESS']
        return supportedBanks.includes(bank)
      }
    },
    supportPhone: {
      isVisible: () => {
        const supportedBanks = ['UCI']
        return supportedBanks.includes(process.env.BANK)
      }
    }
  }
}

export default componentConfig
